import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';
import { breakpoints } from 'stylesheet';

export const Styles = {
  Wrapper: styled.div`
    margin-top: ${defaultTheme.spacing(15)};
    @media (max-width: ${breakpoints.small}) {
      margin-top: ${defaultTheme.spacing(6)};
    }
  `,
  Content: styled.div`
    margin-top: ${defaultTheme.spacing(5)};
    @media (max-width: ${breakpoints.small}) {
      margin-top: ${defaultTheme.spacing(4)};
    }
  `,
  Row: styled.div<{ column?: boolean }>`
    display: flex;
    width: 100%;
    align-items: center;
    margin-bottom: ${defaultTheme.spacing(5)};
    @media (max-width: ${breakpoints.small}) {
      ${props => props.column && `flex-direction: column; align-items: flex-start`};
      margin-bottom: ${defaultTheme.spacing(4)};
    }
  `,
};
